<template>
  <TransitionRoot appear :show="showInstallPrompt" as="template">
    <Dialog as="div" @close="closePrompt" class="relative z-50">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/25" />
      </TransitionChild>

      <div class="fixed inset-x-0 bottom-0 z-50">
        <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="translate-y-full"
          enter-to="translate-y-0"
          leave="duration-200 ease-in"
          leave-from="translate-y-0"
          leave-to="translate-y-full"
        >
          <DialogPanel class="w-full transform overflow-hidden bg-white p-6 shadow-xl transition-all">
            <div class="flex items-start space-x-4">
              <!-- App Icon -->
              <div class="flex-shrink-0">
                <img 
                  src="/pitcar-modified.png" 
                  alt="PITCAR" 
                  class="w-16 h-16 rounded-xl"
                />
              </div>

              <!-- Content -->
              <div class="flex-1">
                <DialogTitle as="h3" class="text-lg font-medium leading-6 text-gray-900">
                  Install PITCAR Rating
                </DialogTitle>
                <p class="mt-2 text-sm text-gray-500">
                  Install aplikasi ini untuk akses lebih cepat dan pengalaman yang lebih baik
                </p>

                <!-- Action Buttons -->
                <div class="mt-4 flex gap-3">
                  <button
                    type="button"
                    class="inline-flex justify-center rounded-lg bg-[#B70000] px-4 py-2 text-sm font-semibold text-white hover:bg-red-800 focus:outline-none"
                    @click="installApp"
                  >
                    Install
                  </button>
                  <button
                    type="button"
                    class="inline-flex justify-center rounded-lg px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50 focus:outline-none"
                    @click="closePrompt"
                  >
                    Nanti Saja
                  </button>
                </div>
              </div>
            </div>
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'

const showInstallPrompt = ref(false)
let deferredPrompt = null

// Listen for install prompt
const handleBeforeInstallPrompt = (e) => {
  e.preventDefault()
  deferredPrompt = e
  showInstallPrompt.value = true
}

const installApp = async () => {
  if (!deferredPrompt) return
  
  deferredPrompt.prompt()
  const { outcome } = await deferredPrompt.userChoice
  
  if (outcome === 'accepted') {
    console.log('App installed')
  }
  
  deferredPrompt = null
  showInstallPrompt.value = false
  
  // Save to localStorage to prevent showing prompt again
  localStorage.setItem('installPromptShown', 'true')
}

const closePrompt = () => {
  showInstallPrompt.value = false
  localStorage.setItem('installPromptShown', 'true')
}

onMounted(() => {
  // Only show prompt if not shown before
  if (!localStorage.getItem('installPromptShown')) {
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
  }
})

onUnmounted(() => {
  window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
})
</script>